<script lang="ts" setup>
import { ColorKeys } from '@afinius/types/Color';
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  variant?: ColorKeys;
  isInvisible?: boolean;
}

withDefaults(defineProps<Props>(), { variant: 'secondary' });
</script>

<template>
  <div class="badge" :class="classNames({ variant, isInvisible })">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use './Badge.scss';
</style>
